<template>
    <div class="side-nav">
        <span class="text-sm">
            <slot name="title">{{ t('header-navigate') }}</slot>
        </span>
        <div class="items">
            <div 
                v-for="item in items" :key="item.value"
                class="item"
                :class="{ active: active === item.value }"
                @click="pick(item)"
            >
                <Icon :icon-class="item.icon" :size="5" color="#6C737F" />
                <span>{{ item.label }}</span>   
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "side-nav",
    props: {
        /**
         * [
         *      {
         *          value: "connections",
         *          label: "Conexões",
         *          icon: "mdi-connection",
         *      },
         * ]
         */
        active: {
            type: String,
        },
        items: {
            type: Array,
            required: true,
        },
    },
    methods: {
        pick(item) {
            this.$emit('pick', item);
        },
    },
}
</script>
<style scoped lang="scss">
.title {
    color: #6C737F;
}
.side-nav {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 188px;
    flex-shrink: 0;
    .items {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .item {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 12px;
            padding: 8px;
            border-radius: 8px;
            background: transparent;
            border: none;
            cursor: pointer;
            &:hover, &.active {
                background: var(--Black-100, #F3F4F6);
            }
        }
    }
}
</style>